<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Assignment Tracking page</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="dark"
                id="addButtonLoaderpro"
                @click="proceedToManualInv"
                >New Billing</b-button
              >
            </b-nav-form>
          </b-navbar-nav> -->
        </b-navbar>

        <b-card>
          <md-layout md-gutter>
            <!-- <md-layout :md-flex="dateRange.startDate?'25':'5'"  >
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
              >
              </date-range-picker>
  
            </md-layout> -->
            <!-- <md-layout md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="clientMaster"
                id="clientNamenew"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="InvoiceNoFilter"
                placeholder=" Invoice Number"
              ></b-form-input>
            </md-layout>  -->
           <!-- <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="SBFilter"
                placeholder=" Shipping Bill No."
              ></b-form-input>
            </md-layout> -->
            <!-- <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="ContainerFilter"
                placeholder=" Container  No."
              ></b-form-input>
            </md-layout> 
            <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="shiperInvFilter"
                placeholder=" Shipper Inv No."
              ></b-form-input>
            </md-layout>  -->
            <!-- <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="assignmentFilter"
                placeholder=" Assignment No."
              ></b-form-input>
            </md-layout> -->

            <!-- <md-layout md-flex="15">
              <model-list-select
                class="ml-3"
                :list="jobList"
                v-model="jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType"
              ></model-list-select>
            </md-layout> -->
            <!-- <md-layout md-flex="15">
              <model-list-select
                class="ml-3"
                :list="branchList"
                v-model="branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder=" Branch"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="15">
              <model-list-select
                class="ml-3"
                :list="invoiceStatusList"
                v-model="statusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </md-layout> -->
            <!-- <md-layout md-flex="50">

            <b-form-group   class="mt-3" >
                  <b-form-checkbox-group
                    id="checkbox-group-1"
                  v-model="jobRecFilter"
                    :options="jobRecList"
                  
                    name="flavour-1"
                  ></b-form-checkbox-group>
                </b-form-group>
            </md-layout> -->

            <md-layout md-flex="25" md-flex-small="100">
              <model-list-select
               isDisabled
                class="ml-3"
                :list="bookingNoList"
                id="clientNamenew"
                v-model="bookingNoFilter"
                option-value="id"
                option-text="request_key"
                placeholder="Select Booking No"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5">
              <h5 class="ml-3">OR</h5>
            </md-layout> -->
            <!-- <md-layout md-flex="25" md-flex-small="100">
              <model-list-select
                class="ml-3"
                :list="blMaster"
                id="clientNamenew"
                v-model="ContainerFilter"
                option-value="id"
                option-text="name"
                placeholder="Select Master BL No"
              ></model-list-select>
            </md-layout> -->
                        
          <md-layout md-gutter>
            <b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-auto"
              
              @click="globalTracking"
              variant="outline-primary"
              >Search</b-button
            >

            <b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-3"
              @click="clearFilter"
              variant="outline-info"
              >clear</b-button
            >
            <!-- <b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-3"
              @click="getReports('BILLING_SCREEN')"
              variant="outline-info"
              >Export as Excel</b-button
            >
<b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-3"
              @click="getReports('BILLING_SCREEN_ALL')"
              variant="outline-info"
              >Export All Execution </b-button
            >
             -->
          </md-layout>
          </md-layout>
          <div class="gutr"></div>
        </b-card>

        <div class="box">
          <!-- <div>
            <b-pagination
              class="mt-3"
              limit="25"
              style="margin: 0px"
              align="right"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalTallyCount }} Entries</small>
          </h5> -->
          <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="100">
              <b-form-input :formatter="capitalizeAll"
                v-model="filter"
                placeholder="Search Assignment"
                @input="viewFFExportFCL('0','1')"
              ></b-form-input>
            </md-layout>
          </md-layout>-->
          <div class="table-responsive tableMain gutr" v-if="containerShippmentDetails.length > 0">
            <b-table
              show-empty
              stacked="md"
              :items="containerShippmentDetails"
              :fields="TrackingFields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="jobType" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>

               <template v-if="dlv.item.dlv_loc" slot="dlv_loc" slot-scope="dlv">
                <span>{{ dlv.item.dlv_loc.name }}</span>
              </template>
            
               <template v-if="org.item.origin_loc" slot="origin_loc" slot-scope="org">
                <span>{{ org.item.origin_loc.name }}</span>
              </template>

               <template v-if="pod.item.pod_loc" slot="pod_loc" slot-scope="pod">
                <span>{{ pod.item.pod_loc.name }}</span>
              </template>

               <template slot="pol_loc" slot-scope="pol">
                <span
                 v-b-toggle.collapse1
                >{{ pol.item.pol_loc.name }}</span>
                 <b-collapse id="collapse1" class="mt-2">
                    <b-card>I am collapsible content A!</b-card>
                </b-collapse>
              </template>

               <template slot="show_details" slot-scope="row4">
              <b-form-checkbox @change="row4.toggleDetails" v-model="row4.detailsShowing"></b-form-checkbox>
            </template>

              <template slot="row-details" slot-scope="row4">
              <b-card style="background:whiteSmoke">

                <b-row>
                  <b-col md="4">
                    <b>Empty Pickup Location : </b>
                
                    <span>{{row4.item.empty_pickup_loc.name}} / {{row4.item.empty_pickup_actual}}</span>
                    <br>

                    <b>Leg1 Vessel / Voyage</b>
                    
                    <span>{{row4.item.leg1_vessel.name}} / {{row4.item.leg1_voyage}} </span>
                     <br>
                     
                     <div v-if="row4.item.leg2_vessel">
                       <b>Leg2 Vessel / Voyage</b>
                       <span>{{row4.item.leg2_vessel.name}} / {{row4.item.leg2_voyage}} </span>
                     </div>

                    <div v-if="row4.item.leg3_vessel">
                       <b>Leg3 Vessel / Voyage</b>
                       <span>{{row4.item.leg3_vessel.name}} / {{row4.item.leg3_voyage}} </span>
                     </div>


                    <div v-if="row4.item.leg4_vessel">
                       <b>Leg4 Vessel / Voyage</b>
                       <span>{{row4.item.leg4_vessel.name}} / {{row4.item.leg4_voyage}} </span>
                     </div>


                    <div v-if="row4.item.leg5_vessel">
                       <b>Leg5 Vessel / Voyage</b>
                       <span>{{row4.item.leg5_vessel.name}} / {{row4.item.leg5_voyage}} </span>
                     </div>


                    
                  </b-col>
                  <b-col md="4" v-if="row4.item.tsp1_loc">

                     <b>tsp1 location : </b>
                
                    <span>{{row4.item.tsp1_loc.name}} </span>
                    <br>
                     <b>tsp1 vsl arrival planned initial : </b>
                
                    <span>{{row4.item.tsp1_vslarrival_planned_initial}} </span>
                    <br>

                    <b>tsp1 vsl departure planned initial</b>
                    
                    <span>{{row4.item.tsp1_vsldeparture_planned_initial}}</span>
                    
                  </b-col>

                  <b-col md="4" v-if="row4.item.tsp2_loc">
                      <b>tsp2 location : </b>
                
                    <span>{{row4.item.tsp2_loc.name}} </span>
                    <br>
                     <b>tsp2 vsl arrival planned initial : </b>
                
                    <span>{{row4.item.tsp1_vslarrival_planned_initial}} </span>
                    <br>

                    <b>tsp1 vsl departure planned initial</b>
                    
                    <span>{{row4.item.tsp1_vsldeparture_planned_initial}}</span>
                  </b-col>
                  
                  <b-col md="4" v-if="row4.item.tsp3_loc">
                      <b>tsp3 location : </b>
                    <span>{{row4.item.tsp3_loc.name}} </span>
                    <br>
                     <b>tsp3 vsl arrival planned initial : </b>
                    <span>{{row4.item.tsp3_vslarrival_planned_initial}} </span>
                    <br>
                    <b>tsp3 vsl departure planned initial</b>
                    <span>{{row4.item.tsp3_vsldeparture_planned_initial}}</span>
                  </b-col>

                  <b-col md="4" v-if="row4.item.tsp4_loc">
                      <b>tsp4 location : </b>
                    <span>{{row4.item.tsp4_loc.name}} </span>
                    <br>
                     <b>tsp4 vsl arrival planned initial : </b>
                    <span>{{row4.item.tsp4_vslarrival_planned_initial}} </span>
                    <br>
                    <b>tsp4 vsl departure planned initial</b>
                    <span>{{row4.item.tsp4_vsldeparture_planned_initial}}</span>
                  </b-col>

                </b-row>
                
              </b-card>
            </template>



              <template slot="mainSalesSeries" slot-scope="row1">
                <!-- <md-icon>{{
                  row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon> -->
                <b>{{ row1.item.jobNo }}</b>
                <br />
                
                <!-- <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment" ? "Sea" : "Air"
                  }}
                  {{ row1.item.transportType }})</span
                >
                <br /> -->
                <!-- <span
                  >Assignment Dt. :
                  {{ row1.item.assignmentDate | moment }}</span
                >
                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> -->
                <!-- <br /> -->
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <br />

                <!-- <h7 class="mt-2" v-if="row1.item.splitFromId!='0'"><b-badge variant="info">Split of {{row1.item.splitFromNo}}</b-badge> </h7> -->
                 
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' &&
                    row11.item.transportType == 'Export'
                  "
                >
                  Client Name : {{ row11.item.clientName }}
                  <br />
                </b>

                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.clientName }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.clientName }}
                  <br />
                </b>
              </template>
              <template slot="ffInvoiceClosed" slot-scope="row2">
                <span v-if="row2.item.jobType.split(',').includes('FF')"
                  >FF :-
                  {{
                    row2.item.ffInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('CC')"
                  >CC :-
                  {{
                    row2.item.ccInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('TPT')"
                  >TPT :-
                  {{
                    row2.item.tptInvoiceClosed == "1"
                      ? "Received"
                      : "Not-Received"
                  }}</span
                >
              </template>
             
              
              
 <template slot="billingSeries" slot-scope="row1000">
                <div v-if="row1000.item.BillingSeries">
                  <span
                    v-for="(item3, index) in row1000.item.BillingSeries.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
                
                <b-button
                  @click="
                     proceedBilling(
                      row1000.item.allModuleId,
                      row1000.item.newContainerFlow,
                      row1000.item.isConsolidation,
                      row1000.item.mainSalesSeries
                    )
                  "
                  variant="outline-primary"
                  size="sm"
                  >{{
                    "Show Invoice"
                  }}</b-button
                >
              </template>
              <!-- <template slot="mainEnquiryId" slot-scope="row15">
                <b-button
                  @click="
                     proceedBilling(
                      row15.item.allModuleId,
                      row15.item.newContainerFlow,
                      row15.item.isConsolidation,
                      row15.item.mainSalesSeries
                    )
                  "
                  variant="primary"
                  size="sm"
                  >{{
                    row15.item.finalBillingCompleted == "1"
                      ? "Show Billing"
                      : "Proceed To Billing"
                  }}</b-button
                >
                <br />
                <b-badge
                  variant="warning"
                  v-if="row15.item.isConsolidation == '1'"
                  >Consolidation</b-badge
                >
              
                <b-badge
                  variant="success"
                  v-if="row15.item.finalBillingCompleted == '1'"
                  >Billing Completed</b-badge
                >
                <b-badge v-else variant="danger">Billing In-complete</b-badge>

                <br />

                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  v-if="row15.item.finalBillingCompleted != '1'"
                  size="sm"
                  @click="validateBilling(row15.item.allModuleId,row15.item.jobType)"
                  variant="outline-info"
                  >Close Billing</b-button
                >
<span style="color:green" v-if="row15.item.assignmentCloseReason">{{row15.item.assignmentCloseReason}}</span>


              </template> -->

            </b-table>
          </div>
        </div>

        <div v-if="false">
          <h5>
            <b-pagination
              limit="25"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </h5>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button
          class="mt-3"
          variant="outline-danger"
          block
          @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
  <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      title="Submit Your Reason"
    centered 
       no-close-on-esc
                      no-close-on-backdrop
                    
                  
                      hide-footer
    >

<h3>Confirmation</h3>
<h4 class="error" v-if="incompleteJobBill"><small>Invoice Not added for </small> {{incompleteJobBill}}  <small> Please Kindly Check..!</small></h4>

      <form ref="form">
        <b-form-group
          label="Reason for closing assignment billing"
          label-for="name-input"
          invalid-feedback="Name is required"
         
        >
          <b-form-textarea :formatter="capitalizeAll"
   rows="5"
            id="name-input"
            v-model="closingReason"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>

<b-button :disabled="closingReason?false:true" variant="success" @click="closeBillOk"> Confirm & Close Billing</b-button>
<b-button @click="closeModalConfirm" variant="danger" class="pull-right"> Cancel</b-button>
    </b-modal>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopApprove"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopReject"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopDelete"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopTally"
    ></md-dialog-confirm>
     <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="notFound"></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE , URL_BASE_DOC} from "../../helper/constant.js";
import {DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    this.getSubscriptionType();
    this.globalTracking();
    lastVisitPage(this.$router.history.current.fullPath);
    // if (globalPermissionStatus("Accounts")) {
    if (true) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/viewBillingDetails/viewBillingDetails"
      );
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        // this.viewFFExportFCL("0", "1", "1");
        console.log("Assignment Tracking page");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }

     
  },

  data() {
    return {
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
closingReason:"",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shipperInv",
          mainkey: "shipperInv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "ShippingB",
          mainkey: "ShippingB",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        {
          key: "ffInvoiceClosed",
          mainkey: "ffInvoiceClosed",
          label: "Execution Invoice",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },

        // {
        //   key: "tptInvoiceClosed",
        //   mainkey: "tptInvoiceClosed",
        //   label: "Invoice Status",
        //   sortable: true,
        //   sortDirection: "ASC"
        // },
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Billing",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "show_details",
        //   mainkey: "tptInvoiceClosed",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],

      InvoiceFields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        // {
        //   key: "containerNo",
        //   mainkey: "containerNo",
        //   label: "Container",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },
        // {
        //   key: "shipperInv",
        //   mainkey: "shipperInv",
        //   label: "Shipper Inv",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },
        // {
        //   key: "ShippingB",
        //   mainkey: "ShippingB",
        //   label: "Shipping Bill",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },

        // {
        //   key: "ffInvoiceClosed",
        //   mainkey: "ffInvoiceClosed",
        //   label: "Execution Invoice",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "Z.",
        // },
        

       
        // {
        //   key: "mainEnquiryId",
        //   mainkey: "mainEnquiryId",
        //   label: "Billing",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      
      ],

      TrackingFields: [
        {
          key: "container_number",
          mainkey: "container_number",
          label: "Container No",
        },
        {
          key: "container_type_str",
          mainkey: "container_type_str",
          label: "Type",
        },
        {
          key: "carrier_name",
          mainkey: "carrier_name",
          label: "Carrier Name"
        },
        {
          key: "dlv_loc",
          mainkey: "dlv_loc",
          label: "dlv loc",
        },
        {
          key: "origin_loc",
          mainkey: "origin_loc",
          label: "origin loc",
          
        },

        {
          key: "pod_loc",
          mainkey: "pod_loc",
          label: "POD"
        },
        {
          key: "pol_loc",
          mainkey: "pol_loc",
          label: "POL",
        },
        {
          key: "show_details",
          mainkey: "departmentName1",
          label: "More Details",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },

        // {
        //   key: "tsp1_loc",
        //   mainkey: "tsp1_loc",
        //   label: "tsp1 loc",
        // },
        

       
        {
          key: "status_verbose",
          mainkey: "status_verbose",
          label: "Status"
        },
      
      ],

      // dateSearch: {
      //   fromDate: "",
      //   toDate: ""
      // },
      // eventId: "",
      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientIdFilter: "",
      assignmentFilter: "",
      ContainerFilter: "",
      blNoFilter : "",
      bookingNoFilter : "",
      shiperInvFilter: "",
      InvoiceNoFilter: "",
      SBFilter: "",
      selectedAllModuleId: "",
      jobTypeFilter: "",
      statusFilter: "0",
      branchfilter: "",
      jobRecFilter: [],
      consoBooking: [],
      shippmentDetails: [],
      containerShippmentDetails : [],
      invoiceTallyList : [],
      totalTallyCount : 0,
      clientMaster: [],
      reload: true,
 jobRecList: [
          { value: '0', text: 'TPT Received' },
          { value: '1', text: 'CC Received' },
          { value: '2', text: 'FF Received' },
         
        ],
  
      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
{
          inv: "3",
          int: "No-Billing",
        },
      ],
      containerMaster: [{
          id : "HLXU8469510",
          name : "HLXU8469510"
      }],
      blMaster: [{
          id : "CSN0168028",
          name : "CSN0168028"
      }],
      bookingMaster: [
        {
          id : "78657098",
          name : "78657098"
        }
      ],

      bookingNoList: [],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
     CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
  },

  computed: {},
  watch: {
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    shiperInvFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    SBFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    ContainerFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    jobTypeFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
     InvoiceNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
  },
  methods: {
  // resetModal() {
  //       this.name = ''
  //       this.nameState = null
  //     },

  getSubscriptionType(){
      // alert("container tracking")
    // this.selectedAllModuleId = id;
  // this.isLoading=true

    // alert(this.ContainerFilter);
  
      let payload = {
        // containerId: this.ContainerFilter
        containerId: 1

      };

      // console.log(this.$sessionsStorage.get("loginId"))

      console.log("Test => ",payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTypes.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {

          
          const { statusText, status, data } = result;

          // alert(statusText+" : "+status+" : "+data)
          if ( status == 200 && data) {
            //alert(data);

           console.log("Type => ",data);

           if (data.BIdType.length > 0){

             this.bookingNoList = data.BIdType;
           }else{
             this.bookingNoList = [];
           }



           

          //  this.isLoading=false
           
            
          }
        })
        .catch((error) => {
          // this.isLoading=false
          console.log("Err => ",error)
        });
  },

  globalTracking(){
      // alert("container tracking")
    // this.selectedAllModuleId = id;
  this.isLoading=true

   if(this.$route.query.trackingId != ""){
        this.bookingNoFilter = this.$route.query.trackingId;

        // this.globalTracking();



    //alert(this.bookingNoFilter);
  
      let payload = {
      
        subscriptionId : this.bookingNoFilter

      };

      // console.log(this.$sessionsStorage.get("loginId"))

      console.log("Test => ",payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {

           this.isLoading=false
          const { statusText, status, data } = result;

          // alert(statusText+" : "+status+" : "+data)
          if ( status == 200 && data) {
            //alert(data);

            console.log("Result => ",JSON.parse(data.data));

            data.data = JSON.parse(data.data);

            this.shippmentDetails.push(data.data);

            if(data.data.containershipments.length > 0){
              this.containerShippmentDetails = data.data.containershipments;
            }else{

              this.alert.content = "No containers found";
              this.$refs["notFound"].open();
            }

            
          }
        })
        .catch((error) => {
          this.isLoading=false
          console.log("Err => ",error)
        });
      }
      else{
         this.isLoading=false
      }



    
  },
validateBilling(id,jobType){
 this.selectedAllModuleId = id;
this.isLoading=true
  
      let payload = {
        allModuleId: id,
        job: jobType,

      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if(data.incompleteJobBill.length>0){
this.incompleteJobBill=data.incompleteJobBill.toString();
}
  this.$refs['modal-close-conf'].show()
this.isLoading=false
          }
        })
        .catch((error) => {});
    

},
 closeModalConfirm() {
this.incompleteJobBill="",

        this.$refs['modal-close-conf'].hide()
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
    getReports(id) {
this.isLoading=true
      let excelIdGivin = "";
      if (id == "BILLING_SCREEN") {
        excelIdGivin = "BILLING_SCREEN";
      }else if(id=="BILLING_SCREEN_ALL"){
 excelIdGivin = "BILLING_SCREEN_ALL";


}
      let view_Assignment = {
        excelId: excelIdGivin,
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.excelName != undefined) {
              window.location.href =
               // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` +
                `https://uploadsp.pridel.com/Pridel_Reports/` +
                data.excelName;

              //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

              // console.log(abc)
            }
this.isLoading=false
          }
        })
        .catch((error) => {});
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    closeBill(id) {
      this.selectedAllModuleId = id;

      this.alert.content = "Are you sure to close Assignment Billing ?";
      this.$refs["addPopTally"].open();
    },
    closeBillOk(type) {
      if (this.closingReason) {
        this.isLoading = true;
        let payload = {
          allModuleId: this.selectedAllModuleId,
          closingReason: this.closingReason,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
this.incompleteJobBill="",

        this.$refs['modal-close-conf'].hide()
          })
          .catch((error) => {});
      }
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        // path: "/allModuleForm/billing"
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.jobTypeFilter = "";
       this.statusFilter = "";
      this.branchfilter = "";
      this.jobRecFilter = [];
      this.assignmentFilter = "";
      this.ContainerFilter = "";
      this.shiperInvFilter = "";
      this.InvoiceNoFilter = "";
      this.SBFilter = "";
this.statusFilter = "0";
this.dateRange={
startDate: "",
        endDate: "",
},
      this.viewFFExportFCL("0", "1", "1");
    },
    proceedBilling(item, id,isConsolidation,mainSalesSeries) {
      this.$sessionsStorage.set("editSalesExId", item);

      // iewBillingDetails/consolidation

    if(isConsolidation == '1'){

      console.log("Consolidation")
      this.$router.push({
          // path: "/allModuleForm/billing"
          path: "/consolidation/viewBillingDetails/"+ item,
          query: { mainSalesSeries: mainSalesSeries }
        });
    }else{
       if (id == "1") {
        this.$router.push({
          // path: "/allModuleForm/billing"
          path: "/allModuleForm/newTallyBillingMerge/" + item,
        });
      } else {
        this.$router.push({
          // path: "/allModuleForm/billing"
          path: "/allModuleForm/billing/" + item,
        });
      }
    }

     
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;

      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },

    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    // goToMain() {
    //   this.$sessionsStorage.set("editallModuleId", "");
    //   this.$router.push({
    //     path: "/allModuleForm/allModuleForm"
    //   });
    // },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM) {
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.consoBooking = [];
      this.invoiceTallyList = [];
        this.totalTallyCount = 0;
      this.isLoading = true;
      let payload = {
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/viewAllInvoiceList_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (
                this.lastVisitPage &&
                this.$sessionsStorage.get("lastVisitPage")
              ) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }

            if (data.assignmentData.length > 0) {
              this.invoiceTallyList = data.invoiceData;
              this.totalTallyCount = data.totalInvoiceData;
            } else {
               this.invoiceTallyList = [];
              this.totalTallyCount =0;
            }

            console.log("Invoice count => ", this.totalTallyCount);


            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.BranchDetailsFinal.length > 0) {
                this.branchList = data.BranchDetailsFinal;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// globalAssignmentTracking.vue?d0804d60